import { render, staticRenderFns } from "./choose.vue?vue&type=template&id=63bd5ecf&scoped=true&"
import script from "./choose.vue?vue&type=script&lang=js&"
export * from "./choose.vue?vue&type=script&lang=js&"
import style0 from "./choose.vue?vue&type=style&index=0&id=63bd5ecf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd5ecf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63bd5ecf')) {
      api.createRecord('63bd5ecf', component.options)
    } else {
      api.reload('63bd5ecf', component.options)
    }
    module.hot.accept("./choose.vue?vue&type=template&id=63bd5ecf&scoped=true&", function () {
      api.rerender('63bd5ecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/choose.vue"
export default component.exports